import React, { Component } from 'react';
import CustomDropdownPractice from '../../components/Inputs/CustomDropdownPractice';
import PropTypes, { array } from 'prop-types';
import practiceConstants from './practiceConstants';

export default class CategoriesMobile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }
  
  static propTypes = {
    onChangeCategory: PropTypes.func.isRequired,
    selectedCategory: PropTypes.object.isRequired,
    categories: PropTypes.array.isRequired,
  };

  selectCategory = (category) => {
    this.props.onChangeCategory(category);
  };

  render() {
    const { categories, selectedCategory } = this.props;
    return (
      <CustomDropdownPractice
        categories={[practiceConstants.allCategory, ...categories]}
        selectedCategory={selectedCategory}
        onChange={this.selectCategory}
        label={'Текущий раздел'}
      />
    );
  }
}